export class Insurer {
  constructor(
    public id: number,
    public name: string,
    public saibaId: number | null,
    public color: string,
    public isLi: boolean,
    public includeLastDate: boolean,
    public isActive: boolean,
    public networkHospital: string,
    public branches: InsurerBranches[],
    public logo: string,
    public shortName: string,
    public integrationKey: string,
    public tpaId?: number | null
  ) {
  }

  static fromJSON(obj: any): Insurer {
    return new Insurer(
      obj.id,
      obj.name,
      obj.saibaId,
      obj.color,
      obj.isLi,
      obj.includeLastDate,
      obj.isActive,
      obj.networkHospital || '',
      obj.branches || [],
      obj.logo || '',
      obj.shortName || obj.name,
      obj.integrationKey || '',
      obj.tpaId || null
    );
  }

  toJSON(): any {
    return {
      id: this.id,
      name: this.name,
      saibaId: this.saibaId,
      color: this.color,
      isLi: this.isLi,
      includeLastDate: this.includeLastDate,
      isActive: this.isActive,
      networkHospital: this.networkHospital,
      branches: this.branches,
      logo: this.logo,
      shortName: this.shortName,
      integrationKey: this.integrationKey,
      tpaId: this.tpaId || null,
    };
  }
}

export interface InsurerBranches {
  id: number,
  name: string,
  insurerId: number,
  saibaId: number | null,
  gstin: string,
  isActive: boolean,
  contacts: InsurerContact[]
}

export interface InsurerContact {
  id: number,
  insurerBranchId: number,
  name: string,
  designation: string,
  email: string,
  phone: number | null,
  isActive: boolean,
  createdAt?: string,
  isVerified: boolean,
  createdBy?: number,
}

export interface InsurerContactConfiguration {
  id: number
  policyTypeId: number,
  insurerContactId: number[],
  isActive: boolean,
}
